module.exports = {"title":"Green Control System","lastUpdated":"Last Updated","refresh":"Refresh","selectGolfClubPlaceholder":"Select a golf club.","totalApl":"Total APL","serviceOperating":"In Service","serviceWaiting":"Idle","lowBattery":"Low Battery","report":"Report","normal":"Normal","error":"Error","batteryStatus":"Battery Status","chargeRequired":"Needs Charging","temperature":"Temperature","aplStatus":"APL Status","batteryLevel":"Battery Level","operating":"Operating","noData":"No data available."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/gr001.json
// module id = 8vJP
// module chunks = 2